<template>
  <div style="background: white; min-height: 100vh; display: flex; flex-direction: column">
    <el-container class="main-con" style="flex: 1">
      <el-header class="index-header">
        <bkHeader></bkHeader>
      </el-header>
      <el-main class="app-main" style="padding: 0">


        <div style="max-width: 1900px; margin: 0 auto; width: 100%; padding: 0 15px;">
          <router-view></router-view>
        </div>
      </el-main>
      <el-footer style="text-align: center; padding: 20px 0; background: #f5f5f5;">
        <p style="color: black; margin: 5px 0; font-size: 14px;">
          Copyright ©2024 不空素材网 版权所有
          <a href="https://beian.miit.gov.cn" target="_blank" style="color: #666;">鲁ICP备2024130023号-1</a>
        </p>
        <a id="jsl_speed_stat0" href="http://defense.yunaq.com/#zid=66c434d1811b3b00ef946ac3"
           target="_blank" style="color: #666; font-size: 14px;">知道创宇云防御</a>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import bkHeader from '../components/header.vue'

export default {
  name: 'index',
  components: {
    bkHeader,
  },
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
      imgList: [
        '/static/hdp/bk.png',
        '/static/hdp/wx.png'
      ]
    }
  },
  methods: {},
  created() {},
  mounted() {
    // 可选：如果需要JavaScript控制的跑马灯效果
    // this.initMarquee();
  }
}
</script>

<style>
/* 基础样式重置 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* 主容器布局 */
.main-con {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.index-header {
  padding: 0 !important;
  height: auto !important;
}

.app-main {
  flex: 1;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}



@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .announcement-bar {
    height: 40px !important;
  }

  .marquee-content {
    font-size: 16px !important;
    line-height: 40px !important;
  }

  .el-footer {
    padding: 15px 0 !important;
  }
}

@media (max-width: 480px) {
  .announcement-bar {
    height: 30px !important;
  }



  .el-footer p, .el-footer a {
    font-size: 12px !important;
  }
}

/* 其他样式清理 */
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue